
/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';
import map from 'lodash/map';

/**
 * `Query` type.
 */

type Query = {
  locale: string,
  slug: string
};

/**
 * Export `fetchFaq`.
 */

export async function fetchFaq({ locale, slug }: Query) {
  const endpoint = getApiEndpoint('getFaq', { slug });

  try {
    const { data } = await request.get(endpoint, {
      headers: acceptLanguageHeader(locale)
    });

    return {
      ...data?.data,
      faqs: map(data?.data?.faqs, ({ attributes, key }) => ({
        ...attributes,
        id: key
      }))
    };
  } catch (error) {
    handleRequestError(error);
  }
}
